import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  width: 100%;\n\n  > div {\n    width: 100%;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { styled } from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import { useRouter } from "next/router";
import { createContext, useContext, useEffect, useRef, useState } from "react";
import useHandoutProductStore from "src/store/relatedProduct";
import { createStore, useStore } from "zustand";
import { getLegacyProduct, getProduct } from "../../api/product";
import { PreviewBookModal } from "../Landing/modals/PreviewBookModal";
import { PassInfoModal } from "../Package/PassInfoModal";
import Modal from "../modal/Modal";
const PreviewDialogContext = /*#__PURE__*/ createContext(null);
export const PreviewDialogProvider = (param)=>{
    let { children  } = param;
    const storeRef = useRef();
    const router = useRouter();
    // const [productDetail, setProductDetail] = useState<IProduct | null>(null)
    const [previewModalOpen, setPreviewModalOpen] = useState(false);
    const { currentProduct , updateCurrentProduct  } = useHandoutProductStore((state)=>({
            updateCurrentProduct: state.updateCurrentProduct,
            currentProduct: state.currentProduct
        }));
    const getProductLegacyMutation = useMutation(getLegacyProduct);
    const getProductMutation = useMutation(getProduct);
    const openPreviewDialog = async (param)=>{
        let { id  } = param;
        try {
            const response = await getProductLegacyMutation.mutateAsync({
                id
            });
            const newProductResponse = await getProductMutation.mutateAsync({
                id
            });
            updateCurrentProduct({
                ...response.product,
                purchaseOptions: newProductResponse.purchaseOptions,
                downloadPrice: newProductResponse.downloadPrice,
                type: newProductResponse.type
            });
            setPreviewModalOpen(true);
        } catch (e) {
            window.alert("교재 정보를 불러오는데 실패했습니다.");
        }
    };
    const closePreviewDialog = ()=>{
        setPreviewModalOpen(false);
        updateCurrentProduct(null);
    };
    if (!storeRef.current) {
        storeRef.current = createStore((set)=>({
                openPreviewDialog,
                closePreviewDialog
            }));
    }
    useEffect(()=>{
        //페이지 이동시 닫혀야함.
        closePreviewDialog();
    }, [
        router
    ]);
    return /*#__PURE__*/ _jsxs(PreviewDialogContext.Provider, {
        value: storeRef.current,
        children: [
            children,
            currentProduct && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(StyledModal, {
                        modalBgColor: "transparent",
                        disableOutsideClick: false,
                        onClose: closePreviewDialog,
                        open: previewModalOpen,
                        name: "mainPreviewModal",
                        children: /*#__PURE__*/ _jsx(PreviewBookModal, {
                            onClose: closePreviewDialog
                        })
                    }),
                    /*#__PURE__*/ _jsx(PassInfoModal, {})
                ]
            })
        ]
    });
};
const StyledModal = styled(Modal)(_templateObject());
export const usePreviewDialogStore = ()=>{
    const store = useContext(PreviewDialogContext);
    if (!store) {
        throw new Error("Missing PreviewDialogProvider");
    }
    return useStore(store);
};
